export default {
  resendPending: 'Resend code in ',
  resendReady: 'Resend code ',
};
